import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  TableFooter,
  Stack,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useSelector } from "react-redux";
import moment from "moment";
import { Close } from "@mui/icons-material";
import { Quicksale_Get_Row_Api } from "../../Server/Apis";
import { httpRequest } from "../../Server/Axios";
import {
  common_locaitonlist_API,
  ORDER_DETAIL_GETROW_API,
} from "../../Server/ApiV2";
import { CmpSelectFieldV1 } from "../../Component/Common/ToolBox/ToolBoxV1";
import theme from "../../Theme";
import CirlceCheckbox from "../../Component/Common/ReuseableComponent/CirlceCheckbox";

const Enquiry = () => {
  const [fromDate, setFromDate] = useState(moment().subtract(1, "days"));
  const [toDate, setToDate] = useState(moment());
  const [selectedLoc, setSelectedLoc] = useState("");
  const [locations, setLocations] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const { UserID } = useSelector((state) => state.login.value);
  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);
  const imgBaseUrl = vRdxDBKernObj.IMAGE_BASE_URL?.Val;
  const handleFilter = async () => {
    try {
      if (selectedLoc) {
        const payload = Quicksale_Get_Row_Api({
          StartDate: moment.utc(fromDate).format("MM/DD/YYYY"),
          EndDate: moment.utc(toDate).format("MM/DD/YYYY"),
          PickingStatus: "",
          DeliveryStatus: "",
          User: UserID || "",
          Loc: selectedLoc || "",
        });
        let res = await httpRequest(payload);
        if (res?.Type && res?.ResultSet)
          setFilteredOrders(res?.ResultSet || []);
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  };

  const getLocation = useCallback(async () => {
    let locationList = await common_locaitonlist_API({
      usercd: UserID,
    });
    if (locationList?.status === 200) {
      if (locationList.data?.ResultSet?.length > 0) {
        setLocations(locationList?.data?.ResultSet);
        setSelectedLoc(locationList?.data?.ResultSet[0]?.UId);
      }
    }
  }, [UserID]);

  useEffect(() => {
    getLocation();
    handleFilter();
  }, []);

  useEffect(() => {
    handleFilter();
  }, [selectedLoc]);

  const handleRowClick = async (order) => {
    setSelectedOrder(order);
    setIsDialogOpen(true);
    try {
      const response = await ORDER_DETAIL_GETROW_API({ ID: order?.ID || "" });
      if (response.status === 200)
        setTableData(response?.data?.ResultSet || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
    setSelectedOrder(null);
    setTableData([]);
  };

  return (
    <>
      {/* Filters Section */}
      <Box
        sx={{
          backgroundColor: "#f5f5f5",
          padding: 3,
          borderRadius: 2,
          boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
          mb: 4,
          mt: 3,
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={3}>
            <DatePicker
              label="From Date"
              value={fromDate}
              inputFormat="DD/MM/YYYY"
              onChange={(newValue) => setFromDate(newValue || moment())}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  sx={{
                    height: "35px",
                    "& input": {
                      padding: "9px",
                    },
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <DatePicker
              label="To Date"
              value={toDate}
              inputFormat="DD/MM/YYYY"
              onChange={(newValue) => setToDate(newValue || moment())}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  sx={{
                    height: "35px",
                    "& input": {
                      padding: "9px",
                    },
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <CmpSelectFieldV1
              xLabelText="locations"
              xValue={selectedLoc}
              xOnChange={(e) => setSelectedLoc(e?.target?.value)}
              xName={"loc"}
              xData={locations ?? []}
              sx={{ height: "100%" }}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={3}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: { xs: "center", md: "flex-start" },
            }}
          >
            <Button variant="contained" color="primary" onClick={handleFilter}>
              Apply Filters
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Typography variant="pageTitle" color="primary">
        Order Enquiry
      </Typography>
      {/* Orders Section */}
      <Box mt={1}>
        {filteredOrders?.length > 0 && (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bolder" }}>Order ID</TableCell>
                  <TableCell sx={{ fontWeight: "bolder" }}>Date</TableCell>
                  <TableCell sx={{ fontWeight: "bolder" }}>Location</TableCell>
                  <TableCell sx={{ fontWeight: "bolder" }}>User</TableCell>
                  <TableCell sx={{ fontWeight: "bolder" }}>Car Model</TableCell>
                  <TableCell sx={{ fontWeight: "bolder" }}>Car Color</TableCell>
                  <TableCell sx={{ fontWeight: "bolder" }}>
                    Picking Status
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bolder" }}>
                    Delivery Status
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bolder" }}>Remarks</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredOrders?.map((order) => (
                  <TableRow
                    key={order.ID}
                    hover
                    sx={{ cursor: "pointer" }}
                    onClick={() => handleRowClick(order)}
                  >
                    <TableCell>{order.ID}</TableCell>
                    <TableCell>
                      {moment(order.Date).format("DD/MM/YYYY")}
                    </TableCell>
                    <TableCell>{order.LocName}</TableCell>
                    <TableCell>{order.OrderUserName}</TableCell>
                    <TableCell>{order.CarModel}</TableCell>
                    <TableCell>{order.CarColor}</TableCell>
                    <TableCell>{order.PickingStatus}</TableCell>
                    <TableCell>{order.DeliveryStatus}</TableCell>
                    <TableCell>{order.DeliveryRemarks}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
      {/* Dialog Section */}
      <Dialog
        open={isDialogOpen}
        onClose={handleDialogClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            backgroundColor: "primary.main",
            color: "white",
            fontWeight: "bold",
          }}
        >
          Order Details
          <IconButton
            aria-label="close"
            onClick={handleDialogClose}
            sx={{
              position: "absolute",
              right: 16,
              top: 16,
              color: "#fff",
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <Box>
            <Box
              sx={{
                backgroundColor: "#f9f9f9",
                padding: 2,
                borderRadius: 2,
                marginTop: 2,
                boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
              }}
            >
              <Stack direction="row" justifyContent={"space-between"}>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bolder",
                    mb: 1,
                    color: theme.palette.primary.main,
                  }}
                >
                  Order Information
                </Typography>
                <CirlceCheckbox
                  status={selectedOrder?.DeliveryStatus.toUpperCase()}
                />
              </Stack>
              <Grid container spacing={2}>
                {/* First Column */}
                <Grid item xs={12} sm={6}>
                  <Box display="flex" flexDirection="column" gap={0.5}>
                    <Box display="flex" justifyContent="space-between">
                      <Typography
                        variant="caption"
                        sx={{
                          fontWeight: "bolder",
                          flex: "1",
                          color: "#000",
                          fontSize: "0.75rem",
                        }}
                        color="text.secondary"
                      >
                        Order ID
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          flex: "1",
                          textAlign: "left",
                          fontSize: "0.75rem",
                        }}
                      >
                        {selectedOrder?.ID}
                      </Typography>
                    </Box>
                    <Box display="flex" justifyContent="space-between">
                      <Typography
                        variant="caption"
                        sx={{
                          fontWeight: "bolder",
                          flex: "1",
                          color: "#000",
                          fontSize: "0.75rem",
                        }}
                        color="text.secondary"
                      >
                        Date
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          flex: "1",
                          textAlign: "left",
                          fontSize: "0.75rem",
                        }}
                      >
                        {moment(selectedOrder?.OrderTime).format("DD-MM-YYYY")}
                      </Typography>
                    </Box>
                    <Box display="flex" justifyContent="space-between">
                      <Typography
                        variant="caption"
                        sx={{
                          fontWeight: "bolder",
                          flex: "1",
                          color: "#000",
                          fontSize: "0.75rem",
                        }}
                        color="text.secondary"
                      >
                        User
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          flex: "1",
                          textAlign: "left",
                          fontSize: "0.75rem",
                        }}
                      >
                        {selectedOrder?.OrderUserName}
                      </Typography>
                    </Box>
                    <Box display="flex" justifyContent="space-between">
                      <Typography
                        variant="caption"
                        sx={{
                          fontWeight: "bolder",
                          flex: "1",
                          color: "#000",
                          fontSize: "0.75rem",
                        }}
                        color="text.secondary"
                      >
                        Car Model
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          flex: "1",
                          textAlign: "left",
                          fontSize: "0.75rem",
                        }}
                      >
                        {selectedOrder?.CarModel}
                      </Typography>
                    </Box>
                    <Box display="flex" justifyContent="space-between">
                      <Typography
                        variant="caption"
                        sx={{
                          fontWeight: "bolder",
                          flex: "1",
                          color: "#000",
                          fontSize: "0.75rem",
                        }}
                        color="text.secondary"
                      >
                        Location
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          flex: "1",
                          textAlign: "left",
                          fontSize: "0.75rem",
                        }}
                      >
                        {selectedOrder?.LocName}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                {/* Second Column */}
                <Grid item xs={12} sm={6}>
                  <Box display="flex" flexDirection="column" gap={0.5}>
                    <Box display="flex" justifyContent="space-between">
                      <Typography
                        variant="caption"
                        sx={{
                          fontWeight: "bolder",
                          flex: "1",
                          color: "#000",
                          fontSize: "0.75rem",
                        }}
                        color="text.secondary"
                      >
                        Car No
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          flex: "1",
                          textAlign: "left",
                          fontSize: "0.75rem",
                        }}
                      >
                        {selectedOrder?.CarNo}
                      </Typography>
                    </Box>
                    <Box display="flex" justifyContent="space-between">
                      <Typography
                        variant="caption"
                        sx={{
                          fontWeight: "bolder",
                          flex: "1",
                          color: "#000",
                          fontSize: "0.75rem",
                        }}
                        color="text.secondary"
                      >
                        Mobile No
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          flex: "1",
                          textAlign: "left",
                          fontSize: "0.75rem",
                        }}
                      >
                        {selectedOrder?.MobileNo}
                      </Typography>
                    </Box>
                    <Box display="flex" justifyContent="space-between">
                      <Typography
                        variant="caption"
                        sx={{
                          fontWeight: "bolder",
                          flex: "1",
                          color: "#000",
                          fontSize: "0.75rem",
                        }}
                        color="text.secondary"
                      >
                        Delivery Person
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          flex: "1",
                          textAlign: "left",
                          fontSize: "0.75rem",
                        }}
                      >
                        {selectedOrder?.DeliveryPerson}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <TableContainer sx={{ mt: 3 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    {[
                      "Image",
                      "Bar Code",
                      "Item Name",
                      "Order Qty",
                      "RSP",
                      "Net Amount",
                    ].map((heading, index) => (
                      <TableCell
                        key={index}
                        sx={{
                          color: "#000",
                          fontWeight: "bolder",
                          textAlign: "center",
                          padding: "8px !important",
                        }}
                      >
                        {heading}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableData?.map((row, index) => (
                    <TableRow
                      key={index}
                      hover
                      sx={{
                        backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff",
                      }}
                    >
                      <TableCell
                        align="center"
                        sx={{
                          // fontSize: "0.7rem",
                          // padding: "8px !important",
                          width: "80px !important",
                          height: "80px !important",
                        }}
                      >
                        <img
                          src={`${imgBaseUrl}Products/${row?.SuppRefNo1}.jpg`}
                          alt={row?.ItmCd}
                          loading="lazy"
                          style={{
                            objectFit: "contain",
                            // borderRadius: "50%",
                            width: "100%",
                            height: "100%",
                            cursor: "pointer",
                          }}
                        />
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ padding: "8px !important" }}
                      >
                        {row.Barcode}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          padding: "8px !important",
                          width: "150px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {row.ItmName}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ padding: "8px !important" }}
                      >
                        {row.Qty}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ padding: "8px !important" }}
                      >
                        {Number(row.VATRSP).toFixed(2)}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ padding: "8px !important" }}
                      >
                        {Number(row.NETAmt).toFixed(2)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TableCell
                      colSpan={5}
                      align="right"
                      sx={{
                        fontWeight: "bolder",
                        padding: "8px !important",
                        color: "#000",
                      }}
                    >
                      <h5>Total:</h5>
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        fontWeight: "bolder",
                        padding: "8px !important",
                        color: "#000",
                      }}
                    >
                      <h5>
                        {tableData
                          ?.reduce((total, row) => total + (row.NETAmt || 0), 0)
                          .toFixed(2)}
                      </h5>
                    </TableCell>
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </Box>
        </DialogContent>

        <DialogActions>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              mt: 3,
            }}
          >
            <Button
              variant="contained"
              color="error"
              onClick={handleDialogClose}
            >
              Close
            </Button>
            <Button variant="contained" color="primary">
              Print
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Enquiry;
